import { i18n } from './i18n';

// Availability helpers shared by product cards, product page and cart
export const availabilityOf = (p) => {
  const warehouse = p.stock ?? 50;
  const supplier = p.supplier_stock || 0;
  const total = p.available_stock ?? (warehouse + supplier);
  const lead = p.lead_time_days ?? 3;
  if (total <= 0) return { status: 'out', total: 0, warehouse, supplier, label: i18n.t('stock.out') };
  if (warehouse <= 0) return { status: 'supplier', total, warehouse, supplier, lead, label: i18n.t('stock.supplier', { n: lead, count: lead }) };
  if (warehouse <= 5) return { status: 'low', total, warehouse, supplier, lead, label: i18n.t('stock.low', { n: warehouse }) + (supplier > 0 ? i18n.t('stock.lowSupplier', { s: supplier, lead }) : '') };
  return { status: 'in', total, warehouse, supplier, label: i18n.t('stock.in') };
};

export const packOptions = (p) => [
  { id: null, label: i18n.t('common.unit'), units: 1, price: p.price },
  ...(p.packs || []).map(k => ({ ...k, saving: Math.round((1 - k.price / (p.price * k.units)) * 100) })),
];

// Quantity tier applying to `qty` units (unit lines only); null if none
export const tierFor = (p, qty) => {
  const tiers = (p.tiers || []).filter(t => t.min_qty <= qty);
  return tiers.length ? tiers.reduce((a, b) => (b.discount_pct > a.discount_pct ? b : a)) : null;
};

export const tierUnitPrice = (p, qty) => {
  const t = tierFor(p, qty);
  return t ? Math.round(p.price * (1 - t.discount_pct / 100) * 100) / 100 : p.price;
};
